"use client";

import { signOut } from "next-auth/react";
import { useEffect } from "react";

export default function InvalidSessionHandler() {
  useEffect(() => {
    // Force logout immediately
    signOut({ callbackUrl: "/" });
  }, []);

  return (
    <div className="flex items-center justify-center h-screen">
      <div className="max-w-md p-8 text-center bg-white rounded-lg shadow-xs">
        <h2 className="mb-4 text-xl font-semibold text-gray-800">
          Session Invalid
        </h2>
        <p className="text-gray-600">
          Your account session is no longer valid. Redirecting to login...
        </p>
      </div>
    </div>
  );
}
